<div id="mainBody">
  <div class="inner_page">
    <div class="wrap">
      <div class="top_line_create">
        <div class="clear"></div>
      </div>
      <div class="new_message bot">
        <div class="head">
          <table style="width: 100%">
            <tbody>
              <tr>
                <td style="vertical-align: top; width: 50%" class="restpasslefttd">
                  {{ "Pages.RestorePassword.LoginHeaderText" | translate }}
                  <br />
                  <div class="check_line">
                    <input
                      type="text"
                      name="login"
                      id="login"
                      class="form-control"
                      [(ngModel)]="login" />
                  </div>
                  <div class="radio_bl check_line">
                    <div style="height: 15px">
                      <input
                        type="radio"
                        id="restoreType_email"
                        class="radio"
                        value="1"
                        name="restoreType"
                        (change)="showResetPasswordButton = true" />
                      <label for="restoreType_email">
                        {{ "Pages.RestorePassword.GetNewPassword" | translate }}
                      </label>
                    </div>
                  </div>

                  <div class="check_line">
                    <app-captcha #captchaComponent></app-captcha>

                    <div class="form-group mt-3">
                      <label for="captchaCode">Введите капчу</label>

                      <div #errorElement
                        class="alert alert-danger small fadeInDown"
                        *ngIf="errorValue">
                        {{ errorValue }}
                      </div>
                      <input
                        class="form-control"
                        id="captchaCode"
                        name="captchaCode"
                        autocomplete="off"
                        placeholder="{{ 'Common.CaptchaText' | translate }}"
                        type="text"
                        [(ngModel)]="captchaCode"
                      />
                    </div>
                  </div>

                  <div
                    *ngIf="showResetPasswordButton"
                    class="btn-group btn-control-group">
                    <a href="javascript:void(0);"
                      (click)="checkCaptcha()"
                      class="start_idea btn btn-primary"
                      id="ResetPasswordNextButton">Далее</a>
                  </div>
                </td>
                <td style="vertical-align: top; padding-left: 20px">
                  <div *ngIf="display == 1" id="d1">
                    <div class="block_info_form">
                      <div class="restleft"></div>
                      <div class="restright">
                        {{ "Pages.RestorePassword.InfoBlock1" | translate }}
                        <br />
                        {{ "Pages.RestorePassword.InfoBlock2" | translate }}
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                  <div *ngIf="display == 2" id="d2">
                    <span>{{ "Pages.RestorePassword.InsertEmail" | translate }}</span>
                    <span></span>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      class="form-control"
                      [(ngModel)]="email"
                    />
                    <div class="btn-group btn-control-group">
                      <a
                        href="javascript:void(0);"
                        (click)="restorePasswordByEmail()"
                        class="start_idea btn btn-primary"
                        id="GetNewPasswordButton">
                        {{
                          "Pages.RestorePassword.GetNewPasswordButtonText" | translate
                        }}
                      </a>
                    </div>
                  </div>
                  <div *ngIf="display == 3">
                    {{ "Pages.RestorePassword.SuccessPasswordRestore" | translate }}
                  </div>
                  <div *ngIf="display == 4">
                    {{ "Pages.RestorePassword.PasswordRestoreWithError" | translate }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
